// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2MnbT","title":"Info_title__3OLRc","selects":"Info_selects__2m6uE","requiredAsterisk":"Info_requiredAsterisk__1belD"};